// utils/getEventTypeImage.js

import eventVaccine from '../images/event-vaccine.png';
import eventParasites from '../images/event-parasites.png';
import eventVet from '../images/event-vet.png';
import eventGroom from '../images/event-grooming.png';
import eventMed from '../images/event-medicine.png';
import eventOther from '../images/type-other.png';

export const getTypeEvent = (eventType) => {
  const typeToImage = {
    'Vaccination': eventVaccine,
    'Anti-Parasitic': eventParasites,
    'Vet Visit': eventVet,
    'Grooming': eventGroom,
    'Medicine': eventMed,
    'Other': eventOther,
  };

  return typeToImage[eventType] || eventOther;
};

/**
 * Иконка типа события: сначала iconUrl из каталога Firestore `eventTypes`, иначе локальный ассет.
 * @param {string} eventType — значение поля eventType (key из каталога)
 * @param {Array<{ key: string, iconUrl?: string | null }> | null | undefined} globalEventTypes
 * @returns {string} — URL картинки (remote или от webpack)
 */
export const resolveEventTypeImageSrc = (eventType, globalEventTypes) => {
  if (!eventType) return eventOther;
  const cfg = Array.isArray(globalEventTypes)
    ? globalEventTypes.find((e) => e.key === eventType)
    : null;
  const url = cfg?.iconUrl;
  if (typeof url === 'string' && url.trim()) {
    return url.trim();
  }
  return getTypeEvent(eventType);
};
